import type { Vessel } from '@/store/vessels/vessel.dto';

export const vesselSlug = (name?: string | null) =>
  (name ?? '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const vesselPath = (vessel: Pick<Vessel, 'id' | 'vessel_name'>) =>
  `/vessels/${vesselSlug(vessel.vessel_name) || vessel.id}`;

export const findVesselBySlug = <T extends Pick<Vessel, 'id' | 'vessel_name'>>(
  vessels: T[] | undefined,
  slug: string | undefined,
): T | undefined => {
  if (!slug) return undefined;
  return (vessels ?? []).find(
    (vessel) => vesselSlug(vessel.vessel_name) === slug || vessel.id === slug,
  );
};
